import React from "react";

import {
    Modal,
    ModalBody,
    FormGroup,
    ModalFooter,
    Button,
    Row, Col
} from "reactstrap";

import ReactTable from "react-table-legacy";

import Request from '../../common/Request';

import InputText from '../FormParts/InputText';
import Definition from '../../common/Definition'
import GoogleDrive from "../../common/GoogleDrive";

export default class SummationSelectPopup extends React.Component {
    default_column = [
        { Header: '見積ID', accessor: 'estimate_natural_id', headerClassName: "text-center", className: "text-left text-top" ,defaultView:true},
        { Header: '顧客情報', accessor: '___JOIN_client_master', headerClassName: "text-center", className: "text-left text-top" ,defaultView:true},
        { Header: '顧客情報（下請）', accessor: '___JOIN_subcontract_customer_information', headerClassName: "text-center", className: "text-left text-top" ,defaultView:true},
        { Header: '契約期間', accessor: '___JOIN_quote_available_date', headerClassName: "text-center", className: "text-left text-top" ,defaultView:true},
        { Header: '仕入情報', accessor: '___JOIN_quote_use_parking', headerClassName: "text-center", className: "text-left text-top" ,defaultView:true},
        { Header: 'アクション', accessor: 'action', headerClassName: "text-center", className: "text-center", sortable : false},
    ];
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            data: [],
            column: this.default_column,
            searchData:{
                values:{},
                errors:{},
                requiredData:{}
            },
            pageIndex:0
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.search = this.search.bind(this);
        this.clickSelectButton = this.clickSelectButton.bind(this);
        this.validate = this.validate.bind(this)
        this.validateCallback = this.validateCallback.bind(this)
    }

    // 初期ロード用
    UNSAFE_componentWillMount() {
        /*　ここは開発者が記述　*/

        // TODO 本番では有効にする
        // this.search("");
    }

    search_params() {
        const {values} = this.state.searchData
            return values&&Object.keys(values).reduce((acc, key)=>{
                if (values[key]){
                    acc[key] = values[key]
                }
            return acc
        },{})
      }
    
    search() {
    /* ここは開発者が記述 */
        if (!this.validate()) {
            // do nothing
            return;
        }
        Request.get('/api/requestpayment/parking', 
            {
                ...this.search_params(),
                payment_request_status : "0",
                user_branch_id: this.props.sdata[Object.keys(this.props.sdata)[0]].user_branch_id
            }
            , res => {
                const selectedList = Object.keys(this.props.sdata).map(keyName=>this.props.sdata[keyName])
                const filterdData = res.Data.filter(mapData => {
                    return !(selectedList.some(selectedData => selectedData.estimate_natural_id === mapData.estimate_natural_id))
                })
                this.setState({
                    data: this.dataMap(filterdData)
                });
        })
    }

    validate() {
        return Object.keys(this.state.searchData.errors).length===0;
    }

    validateCallback(newData, callback=()=>{}){
        this.setState({
            searchData:{
            ...this.state.searchData,
            ...newData
            }
        }, ()=>callback())
    }

    dataMap(data) {
        return data.map((prop, key) => {
            return {
                id: key,
                estimate_natural_id: (<a href={GoogleDrive.getOpenUrl(prop.latest_pdf_survey_url)} target="_blank">{prop.estimate_natural_id}</a>),
                ___JOIN_client_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />,
                ___JOIN_subcontract_customer_information: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information', prop)}} />,
                ___JOIN_quote_available_date: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_available_date', prop)}} />,
                ___JOIN_quote_use_parking: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_use_parking', prop)}} />,
                action: (<Button type="button" color="default" className="btn-sm" onClick={() => { this.clickSelectButton(prop); }}>追加</Button>)
            }
        });
    }

    clickSelectButton(prop) {
        if (this.props.summationSelectedCallback) {
            this.props.summationSelectedCallback(prop);
        }
        this.setState({ data : [] })
        this.toggleModal();
    }

    show() {
        this.setState({ modal: true });
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <Modal size="xlg" isOpen={this.state.modal}>
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleModal}>
                        <i className="tim-icons icon-simple-remove"></i>
                    </button>
                    <span style={{width: "100%"}}>
                        <h5 className="modal-title float-left">見積検索</h5>
                    </span>
                </div>
                <ModalBody>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <InputText
                                    label='見積ID'
                                    name='ESTIMATE__estimate_natural_id'
                                    labelOn={true}
                                    validateCallback={this.validateCallback}
                                    enterCallback={()=>{
                                        this.setState({
                                            pageIndex:0
                                        })
                                        this.search()
                                    }}
                                    enterSearchFlag={true}
                                    rootData={this.state.searchData}
                                    validateType={'search'}
                                    />
                            </FormGroup>
                            <Button onClick={()=>{
                                        this.setState({
                                            pageIndex:0
                                        })
                                        this.search()
                                    }}>検索</Button>
                        </Col>
                    </Row>
                    <Row>
                        <ReactTable
                            page={this.state.pageIndex}
                            onPageChange={(pageIndex)=>{
                                this.setState({
                                    pageIndex
                                })
                            }}
                            style={{ width: '100%' }}
                            data={this.state.data}
                            columns={this.state.column}
                            defaultPageSize={5}
                            filterable={false}
                            showPageSizeOptions={false}
                            showPaginationTop={true}
                            showPaginationBottom={true}
                            previousText="前へ"
                            nextText="次へ"
                            rowsText="件表示"
                            loadingText='読込中…'
                            noDataText='データが有りません。'
                            pageText=''
                            ofText='/'
                            className="-highlight primary-pagination"
                        />
                    </Row>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        );
    }
}
